"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.put = function (key, value) {
    window.localStorage.setItem(key, value);
};
exports.get = function (key) { return window.localStorage.getItem(key); };
exports.remove = function (key) { return window.localStorage.removeItem(key); };
exports.clear = function () {
    window.localStorage.clear();
};
exports.safePut = function (key, value) {
    exports.put(key, JSON.stringify(value));
};
exports.safeGet = function (key) {
    try {
        return JSON.parse(exports.get(key));
    }
    catch (e) {
        console.warn('unable to get for key: ' + key, e);
    }
};
//# sourceMappingURL=storage.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/utils/storage.js
// module id = 61
// module chunks = 0